import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import yashiApply from '@/pages/yashiApply'
import cluse from '@/pages/cluse'
import privacy from '@/pages/privacy'
import announcement from '@/pages/announcement'
import questionnaire from '@/pages/questionnaire/index.vue'
import success from '@/pages/questionnaire/success.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/yashiApply',
      name: 'yashiApply',
      component: yashiApply
    },
    {
      path: '/cluse',
      name: 'cluse',
      component: cluse
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: announcement
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: questionnaire
    },
    {
      path: '/questionnaire/success',
      name: 'success',
      component: success
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js